// INFO EMAILJS

const mail = {
    USER_ID : "user_DADyw8JhdlzIdmwmXLNbU",

    TEMPLATE_ID : "test"
}

export default mail